import {di} from "@dp-instant/core";
import {LevelNextAction} from "@dp-instant/gameflow";
import {TypesUI} from "@dp-instant/interfaces";
import {UIEvents} from "@dp-instant/ui";
import {GameModel} from "@game/coregame/model/GameModel";
import {GameState} from "@game/coregame/model/GameState";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable} from "inversify";
import {SocialEvents} from "@dp-instant/social";
import {DestroyFieldAction} from "@game/coregame/actions/DestroyFieldAction";

@injectable()
export class LevelNextActionSIO extends LevelNextAction {
    @inject(TypesGame.model)
    private model: GameModel;

    protected async gotoNextLevel(waitForContextChange = false) {
        this.levelStart.waitForContextChange = waitForContextChange;

        this.model.cookie.syncTime();
        if (this.model.gotoNextLevelStage()) {
            this.model.startStage();
        } else {
            await di.get(DestroyFieldAction).run();
            await this.levelStart.run();
        }
        new Promise(resolve => this.social.once(SocialEvents.CONTEXT_CHANGE, resolve)).then(() => {
            if (this.model.state === GameState.GAMEPLAY) {
                const participants = this.model.getAssociatedUsers();

                this.dispatch(UIEvents.SCREEN_CHANGED, {
                    id: TypesUI.screen.GAMEPLAY,
                    props: {participants}
                });
            }
        });
    }
    protected async playNextSolo() {
        return this.gotoNextLevel(); // keep the context
    }
}
